import ColourPreview from './ColourPreview';
import { ColourPreviewProps, ColourPreviewValueProps } from './types';

export type { ColourPreviewProps, ColourPreviewValueProps };
export default ColourPreview;
